import { GoogleCalendar, ICalendar } from 'datebook';
import type { IMatch } from '@/interface/IMatch';
import { TimezoneOffset } from '@/interface/enum';
import { getTranslated } from '@/libraries/helpers/translationHelper';
import { getSportsBsiUrl } from '@/libraries/url';
import { addHour, parseDate } from '@/libraries/utils/date';
import { isMobile, isSafari } from '@/libraries/utils/userAgent';

export function addToCalendar(info: IMatch) {
    if (!info.showTime) {
        return;
    }

    const startDate = parseDate(info.showTime, 'MM/dd/yyyy HH:mm', TimezoneOffset.Singapore);
    const homeTeamName = getTranslated(info.homeTeam?.teamName);
    const awayTeamName = getTranslated(info.awayTeam?.teamName);

    const config = {
        title: `${homeTeamName} -vs- ${awayTeamName}`,
        description: `${getTranslated(info.leagueName)} - Get ready to bet live at ${getSportsBsiUrl()}!`,
        start: startDate,
        end: addHour(startDate, 2),
    };

    if (!isMobile() || isSafari()) {
        const iCalendar = new ICalendar(config);
        iCalendar.addAlarm({
            action: 'DISPLAY',
            trigger: { minutes: 15 },
        });
        const icsContent = iCalendar.render();
        const blob = new Blob([icsContent], { type: 'text/calendar' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'event.ics';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        const googleCalendar = new GoogleCalendar(config);
        window.open(googleCalendar.render());
    }
}
